import { useNavigate } from 'react-router-dom';
import { Fragment, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

const Resources = () => {
  const navigate = useNavigate();

  const resourceList = [
    {
      title: "NSPS Standards",
      category: "Professional Authority",
      description: "The National Society of Professional Surveyors provides the ethical and technical standards for the industry.",
      link: "https://nsps.us.com/",
      icon: "⚖️"
    },
    {
      title: "Google Earth Pro",
      category: "Interactive Tool",
      description: "Research your property's topography and historical satellite imagery using advanced mapping tools.",
      link: "https://www.google.com/earth/versions/#earth-pro",
      icon: "🌍"
    },
    {
      title: "ALTA Land Surveys",
      category: "Educational Guide",
      description: "Understand the complex requirements for American Land Title Association surveys used in commercial real estate.",
      link: "https://www.alta.org/",
      icon: "📋"
    },
    {
      title: "Land Survey Records",
      category: "Data Research",
      description: "A digital warehouse to search for existing legal survey maps and historical property boundaries.",
      link: "https://www.landsurveyrecords.com/",
      icon: "🔍"
    },
    {
      title: "Surveying Glossary",
      category: "Learning",
      description: "Confused by terms like 'Easement' or 'Encroachment'? Learn the language of land surveying here.",
      link: "https://leica-geosystems.com/industries/pure-surveying/all-about-land-surveying",
      icon: "📖"
    },
    {
      title: "USGS National Map",
      category: "Government GIS",
      description: "Access high-quality elevation data, hydrography, and official boundary datasets from the USGS.",
      link: "https://apps.nationalmap.gov/downloader/",
      icon: "🏛️"
    }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <Header />
      <div className="min-h-screen px-4 py-16 bg-slate-50 sm:px-6 lg:px-8">
        
        {/* Header Block */}
        <div className="max-w-7xl mx-auto mb-12">
          <h1 className="text-3xl font-extrabold tracking-tight text-blue-950 sm:text-4xl">Industry Resources</h1>
          <p className="mt-3 text-base text-slate-600 max-w-2xl">Research official land surveying standards, processing tools, and public geospatial directories.</p>
        </div>

        {/* Resource Grid Layout Container */}
        <div className="grid max-w-7xl grid-cols-1 gap-8 mx-auto sm:grid-cols-2 lg:grid-cols-3">
          {resourceList.map((res, index) => (
            <div key={index} className="flex flex-col justify-between p-6 bg-white border border-slate-100 shadow-sm rounded-2xl transition-all duration-300 hover:shadow-md">
              <div>
                <div className="flex items-center justify-between mb-4">
                  <span className="text-3xl">{res.icon}</span>
                  <span className="text-[11px] font-bold tracking-wider text-blue-600 bg-blue-50 px-2.5 py-1 rounded-md uppercase">
                    {res.category}
                  </span>
                </div>
                <h3 className="mb-2 text-xl font-bold text-slate-800 tracking-tight">{res.title}</h3>
                <p className="text-sm leading-relaxed text-slate-600">{res.description}</p>
              </div>
              
              <a 
                href={res.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="inline-block px-4 py-2.5 mt-6 text-sm font-semibold text-center text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors shadow-sm"
              >
                Visit Resource
              </a>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default Resources;